var portfolioTransactionEdit = {
	title: "Editar transacción",
	subTitle: "Portafolio: {name}",
	buy: "Comprar",
	sell: "Vender",
	buyDate: "Fecha de compra",
	sellDate: "Fecha de venta",
	quantity: "Cantidad/Nominal",
	buyPrice: "Precio de compra",
	exchangeRate: "Tasa de Cambio",
	exchangeRateFormat: "{from}/{to}",
	confirmBtn: "Ok",
	cancelBtn: "Cancelar",
	buyValueInPortfolioCurrency: "Valor de Compra (moneda de la cartera de inversión)",
	buyValueInNotationCurrency: "Valor de Compra (moneda de cotización)",
	sellValueInPortfolioCurrency: "Valor de Venta (moneda de la cartera de inversión)",
	sellValueInNotationCurrency: "Valor de Venta (moneda de cotización)",
	transactionType: "Tipo de Transacción",
	sellPrice: "Precio de venta",
	validationErrors: {
		buyDate: {
			invalidInput: "El formato de la fecha es inválido. Formato válido aaaa-MM-dd'T'HH: mm"
		},
		buyPrice: {
			invalidInput: "Precio no válido."
		},
		exchangeRate: {
			invalidInput: "Tipo de cambio inválido"
		},
		quantity: {
			invalidInput: "Cantidad inválida"
		}
	}
};
var es = {
	portfolioTransactionEdit: portfolioTransactionEdit
};

export { es as default, portfolioTransactionEdit };
